import { CONNECTION_STATUS } from '@/utils/system/SystemConnection'

const SET_USER_CONNECTION_STATUS = 'SET_USER_CONNECTION_STATUS'
const SET_SOCKET_STATUS = 'SET_SOCKET_STATUS'
const SET_EMQX_STATUS = 'SET_EMQX_STATUS'
const SET_GENERAL_API_STATUS = 'SET_GENERAL_API_STATUS'
const SET_LIVE_API_STATUS = 'SET_LIVE_API_STATUS'
const SET_SHOW_CONNECTION_INFORM = 'SET_SHOW_CONNECTION_INFORM'

const _state = {
  userConnectionStatus: CONNECTION_STATUS.ERROR,
  generalApiStatus: CONNECTION_STATUS.GOOD,
  liveApiStatus: CONNECTION_STATUS.GOOD,
  socketStatus: CONNECTION_STATUS.ERROR,
  emqxStatus: CONNECTION_STATUS.ERROR,
  isReconnecting: false,
  showConnectionInform: false,
}

const getters = {
  userConnectionStatus: (state) => state.userConnectionStatus,
  generalApiStatus: (state) => state.generalApiStatus,
  liveApiStatus: (state) => state.liveApiStatus,
  socketStatus: (state) => state.socketStatus,
  emqxStatus: (state) => state.emqxStatus,
  showConnectionInform: (state) => state.showConnectionInform,
  connectionStatus: (state, _getters, _rootState, rootGetters) => {
    if (state.isReconnecting) {
      return CONNECTION_STATUS.RECONNECTING
    }
    if (rootGetters['featureToggles/canUseNetworkIndicatorV2']) {
      // With the V2 indicator, a dropped real-time channel (socket or EMQX) is
      // also a "reconnecting" state, not just a lost user/internet connection.
      if (
        state.userConnectionStatus === CONNECTION_STATUS.ERROR ||
        state.socketStatus === CONNECTION_STATUS.ERROR ||
        state.emqxStatus === CONNECTION_STATUS.ERROR
      ) {
        return CONNECTION_STATUS.RECONNECTING
      }
      // A failed general-API request surfaces as a server error (ranked below a
      // real-time drop, above a merely-unstable API).
      if (state.generalApiStatus === CONNECTION_STATUS.ERROR) {
        return CONNECTION_STATUS.ERROR
      }
    } else if (state.userConnectionStatus === CONNECTION_STATUS.ERROR) {
      return CONNECTION_STATUS.RECONNECTING
    }
    if (state.generalApiStatus === CONNECTION_STATUS.UNSTABLE) {
      return CONNECTION_STATUS.UNSTABLE
    }
    return CONNECTION_STATUS.GOOD
  },
}

const actions = {
  setUserConnection({ commit }, payload) {
    commit(SET_USER_CONNECTION_STATUS, payload)
    if (payload === CONNECTION_STATUS.ERROR) {
      commit(SET_SHOW_CONNECTION_INFORM, true)
    }
  },
  setSocketConnection({ commit }, payload) {
    commit(SET_SOCKET_STATUS, payload)
  },
  setEmqxConnection({ commit }, payload) {
    commit(SET_EMQX_STATUS, payload)
  },
  setGeneralApiConnection({ commit }, payload) {
    commit(SET_GENERAL_API_STATUS, payload)
  },
  setLiveApiConnection({ commit }, payload) {
    commit(SET_LIVE_API_STATUS, payload)
  },
  setShowConnectionInform({ commit }, payload) {
    commit(SET_SHOW_CONNECTION_INFORM, payload)
  },
}

const mutations = {
  [SET_USER_CONNECTION_STATUS](state, payload) {
    state.userConnectionStatus = payload
  },
  [SET_SOCKET_STATUS](state, payload) {
    state.socketStatus = payload
  },
  [SET_EMQX_STATUS](state, payload) {
    state.emqxStatus = payload
  },
  [SET_GENERAL_API_STATUS](state, payload) {
    state.generalApiStatus = payload
  },
  [SET_LIVE_API_STATUS](state, payload) {
    state.liveApiStatus = payload
  },
  [SET_SHOW_CONNECTION_INFORM](state, payload) {
    state.showConnectionInform = payload
  },
}

export default {
  namespaced: true,
  state: _state,
  getters,
  actions,
  mutations,
}
